module.exports = __webpack_public_path__ + "static/media/eSports-controller-icon_2-color.452d0b32.svg";